/* eslint-disable import/prefer-default-export */

export const FOLLOW_UP_MODAL_CLOSED = 'FOLLOW_UP_MODAL_CLOSED';
export const FOLLOW_UP_CHANGED = 'FOLLOW_UP_CHANGED';
export const FOLLOW_UP_ARTIST_CHANGED = 'FOLLOW_UP_ARTIST_CHANGED';
export const FOLLOW_UP_REMIND_AT_CHANGED = 'FOLLOW_UP_REMIND_AT_CHANGED';
export const FOLLOW_UP_NOTE_CHANGED = 'FOLLOW_UP_NOTE_CHANGED';
